/**
 * FREED Magnetic Button Effect
 * Desktop only (hover: hover media query).
 * On mousemove: button drifts toward cursor, max 8px.
 * On mouseleave: snaps back to rest position.
 */
(function () {
  'use strict';

  // Desktop / pointer devices only
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MAX_PX = 8;

  var BUTTON_SELECTORS = [
    '.freed-btn-primary',
    '.freed-slideshow__btn',
    '.freed-collection-banner__btn',
    '.freed-newsletter__btn',
    '.freed-brand-story__btn',
    '.freed-product__atc',
    '.freed-product__buy-now'
  ].join(',');

  function attachMagnetic(btn) {
    if (btn.hasAttribute('data-freed-magnetic')) return;
    btn.setAttribute('data-freed-magnetic', '1');

    var rect = null;
    var rafId = null;
    var pendingX = 0, pendingY = 0;

    btn.addEventListener('mouseenter', function () {
      rect = btn.getBoundingClientRect(); // cache once on enter
    });

    btn.addEventListener('mousemove', function (e) {
      if (!rect) rect = btn.getBoundingClientRect();
      pendingX = e.clientX;
      pendingY = e.clientY;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var nx = (pendingX - cx) / (rect.width / 2);
        var ny = (pendingY - cy) / (rect.height / 2);
        var dx = Math.max(-1, Math.min(1, nx)) * MAX_PX;
        var dy = Math.max(-1, Math.min(1, ny)) * MAX_PX;
        btn.style.transition = 'transform 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        btn.style.transform = 'translateX(' + dx.toFixed(2) + 'px) translateY(' + dy.toFixed(2) + 'px)';
      });
    });

    btn.addEventListener('mouseleave', function () {
      rect = null;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      btn.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.3s ease';
      btn.style.transform = '';
    });
  }

  function initMagnetic() {
    document.querySelectorAll(BUTTON_SELECTORS).forEach(attachMagnetic);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMagnetic);
  } else {
    initMagnetic();
  }
})();
